import { Component, Input, Output, EventEmitter, HostListener, ViewChild, ElementRef, Pipe, PipeTransform } from '@angular/core';
import { Recipient } from '../../../models';



declare var $: JQueryStatic;

@Pipe({
  name: 'Filter'
})
export class FilterPipe implements PipeTransform {

  constructor() { }

  transform(lst: Array<{ value: string }>, value: string, selectedList: Array<string> = []): Array<any> {
    if (lst && lst.length > 0) {
      const lstFiltered: Array<{ value: string }> = JSON.parse(JSON.stringify(lst));

      if (lstFiltered && lstFiltered.length > 0) {
        for (let i: number = 0; i < lstFiltered.length; i++) {
          const element: { value: string } = lstFiltered[i];
          const index: number = selectedList.findIndex((x: any) => x === element.value);
          if (index > -1) {
            lstFiltered.splice(i, 1);
            i--;
          } else if (!!value && !element.value.toLowerCase().includes(value.toLowerCase())) {
            lstFiltered.splice(i, 1);
            i--;
          }
        }
      }
      return lstFiltered;
    }
    return [];
  }
}



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-inputmail-list',
  templateUrl: './inputmail-list.component.html',
  styleUrls: ['./inputmail-list.component.css']
})

export class InputMailListComponent {
  public list: Array<string>;
  public placeholder: string = '';
  public regex: RegExp | null = null;
  public datalistIsEmpty: boolean = false;
  public disabled: boolean = false;
  public inputValue: string = '';
  public datalist: Array<Recipient> = new Array<Recipient>();

  @Input('list') set Setlist(value: Array<string>) {
    this.list = JSON.parse(JSON.stringify(value));
  };
  @Input('datalist') set SetDataList(value: Array<Recipient>) {
    this.datalist = JSON.parse(JSON.stringify(value));
  };

  @Input() propName: string;
  @Input() idContact: string;
  @Input('placeholder') set SetPlaceholder(value: string) {
    this.placeholder = value;
  }
  @Input('disabled') set SetDisabled(value: boolean) {
    this.disabled = value;
  }

  @Input('regex') set setRegex(value: RegExp) {
    this.regex = value;
  }
  @Output() listChange: EventEmitter<Array<string>> = new EventEmitter<Array<string>>();

  public ToggleInputButton(event: any, index: number, action: string): void {
    switch (action) {
      case 'edit':
        $(event.target).each(function () {
          const parent = this.parentElement;
          (parent as HTMLElement).style.display = 'none';
          ((parent as HTMLElement).nextElementSibling as HTMLElement).style.display = 'flex';
          const inputElement: HTMLInputElement = (((parent as HTMLElement).nextElementSibling as HTMLElement).children[0] as HTMLInputElement);
          inputElement.focus();
          inputElement.selectionStart = inputElement.selectionEnd = 10000;
        });
        break;
      case 'view-keyup':
      case 'view':
        $(event.target).each((i, that) => {
          if ($(that).parent().parent().hasClass('wrong-email')) {
            $(that).parent().parent().removeClass('wrong-email');
          }
          if (action !== 'view-keyup' || event.key === ' ' || event.key === 'Tab' || event.key === 'Enter') {
            (that as HTMLInputElement).value = (that as HTMLInputElement).value.replace(/ /g, '');
            if (!this.regex || this.regex.test((that as HTMLInputElement).value)) {
              const parent = that.parentElement;
              (parent as HTMLElement).style.display = 'none';
              ((parent as HTMLElement).previousElementSibling as HTMLElement).style.display = 'flex';
              this.listChange.emit(this.list);
            } else if ((that as HTMLInputElement).value === '') {
              this.list.splice(i, 1);
            } else {
              $(that).focus();
              (that as HTMLInputElement).selectionStart = (that as HTMLInputElement).selectionEnd = 10000;
              $(that).parent().parent().addClass('wrong-email');
            }
          }
        });
        break;
    }
  }

  public RemoveItemFromList(index: number): void {
    this.list.splice(index, 1);
    this.listChange.emit(this.list);
    this.datalistIsEmpty = this.ListIsEmpty(this.datalist.map((obj: any) => obj[this.propName]), this.list);
  }
  public AddItemToList(event: any, action: string): void {
    if ($(event.target).parent().hasClass('wrong-email')) {
      $(event.target).parent().removeClass('wrong-email');
    }
    if ((action === 'blur' && this.inputValue != '') || (action === 'keyup' && event.key === ' ' || event.key === 'Tab' || event.key === 'Enter')) {
      this.inputValue = this.inputValue.replace(/ /g, '');
      if (!this.regex || this.regex.test(this.inputValue)) {
        this.list.push(this.inputValue);
        this.inputValue = '';
        this.listChange.emit(this.list);
      } else if (!!this.inputValue) {        
        $(event.target).parent().addClass('wrong-email');
      }
    }
    this.datalistIsEmpty = this.ListIsEmpty(this.datalist.map((obj: any) => obj[this.propName]), this.list);
  }
  public AddDataListItemToList(value: string) {
    this.list.push(value);
    this.inputValue = '';
    this.datalistIsEmpty = this.ListIsEmpty(this.datalist.map((obj: any) => obj[this.propName]), this.list);
      this.listChange.emit(this.list);
  }

  public trackByFn(index: number, item: any) {
    return index;
  }

  private ListIsEmpty(lst: Array<Array<{ value: string }>>, selectedList: Array<string> = []): boolean {
    if (lst && lst.length > 0) {
      const lstFiltered: Array<Array<{ value: string }>> = JSON.parse(JSON.stringify(lst));
      let isEmpty: boolean = true;
      for (let i: number = 0; i < lstFiltered.length; i++) {
        const list: Array<{ value: string }> = lstFiltered[i];
        if (list && list.length > 0) {
          for (let j: number = 0; j < list.length; j++) {

            const element: { value: string } = list[j];
            const index: number = selectedList.findIndex((x: any) => x === element.value);
            if (index > -1) {
              lstFiltered[i].splice(j, 1);
              j--;
            }
          }
          if (lstFiltered[i].length > 0) {
            isEmpty = false;
            break;
          }
        }
      };

      return isEmpty;
    }
    return true;
  }
}

